import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { getLogin, getTokenVerify } from 'redux/actions/UserLogin';
import CommonForm from 'components/commonForm/CommonForm';
import Loader from 'components/loader/Loader';
import Otp from 'pages/otp/Otp'
import loginHand from 'assets/images/login_hand.png';
import { companyDetails } from 'utils/companyDetails';
import { getBranding, loadTenantConfig, rememberTenantId } from 'config/tenantConfig';
import { injectTheme } from 'config/themeInjector';
import { identifyApi } from 'services/LoginService';
import TenantPicker from 'components/tenantPicker/TenantPicker';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searhParams] = useSearchParams()
  const magicToken = searhParams?.get('magicToken')
  const userLogin = useSelector((state) => state);
  const isLoader = userLogin?.userLogin?.loading;
  const [onOtp, setOnOtp] = useState(false)

  //if we click on switch functionality b2b to b2c then this function will be call
  useEffect(() => {
    if(magicToken){
      dispatch(getTokenVerify(magicToken))
    }
  }, [magicToken]);

  useEffect(() => {
    setOnOtp(false);
  }, []);

  const handleredirect = () => {
    navigate('/signup')
  }

  const onOtpPage = (val) => {
    setOnOtp(val)
  }
  
  const loginFormSubVendor = [
    {
      placeholder: 'Enter your Email ID or Mobile Number',
      required: true,
      type: 'text',
      name: 'mobileOrEmail',
      label: 'Email ID or Mobile number',
      star: '*',
      countrycode: false,
    },
  ];

  const [tenantChoices, setTenantChoices] = useState([]);
  const [pendingLogin, setPendingLogin] = useState(null);

  const proceedLogin = (loginPayload) => {
    // dispatchEvent(call redux function: action -> saga -> reducer (update the store)
    dispatch(getLogin(loginPayload, navigate, setOnOtp));
  };

  const applyTenant = (tenantId) => {
    rememberTenantId(tenantId);
    // Refresh branding for the chosen tenant (fire-and-forget).
    loadTenantConfig()
      .then(injectTheme)
      .catch(() => {});
  };

  const onLogin = async (data, code) => {
    localStorage.clear();
    const loginPayload = {
      userDetails: {
        platform: 'AdminApp',
        mobileOrEmail: data.mobileOrEmail,
        countryCode: data?.countryCode || '+91',
      },
      actionType: "login"
    }

    // Identify-first (common-URL) login: ask which tenant(s) know this user.
    // Any failure or empty result falls through to the normal login flow so
    // subdomain deployments are unaffected.
    try {
      const identifyRes = await identifyApi({
        platform: 'AdminApp',
        mobileOrEmail: data.mobileOrEmail,
        countryCode: data?.countryCode || '+91',
      });
      const tenants =
        identifyRes?.success && Array.isArray(identifyRes.data) ? identifyRes.data : [];
      if (tenants.length === 1) {
        applyTenant(tenants[0].tenantId);
      } else if (tenants.length > 1) {
        setPendingLogin(loginPayload);
        setTenantChoices(tenants);
        return; // wait for the user's pick (or cancel)
      }
    } catch (e) {
      // fail-open: proceed with login exactly as before
    }
    proceedLogin(loginPayload);
  };

  const onTenantSelect = (tenant) => {
    const loginPayload = pendingLogin;
    setTenantChoices([]);
    setPendingLogin(null);
    applyTenant(tenant?.tenantId);
    if (loginPayload) proceedLogin(loginPayload);
  };

  const onTenantCancel = () => {
    setTenantChoices([]);
    setPendingLogin(null);
  };

  return (
    <div>
      {onOtp === false &&<Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
      {magicToken ? <Loader/> : <Grid container>
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                  }}
                  className="positionAbsolute"
                >
                  <img src={getBranding().logo || companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                </Box>
            {/* ---login input type--- */}
            <div className="loginInput mobileBg">
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={10} className='textCenter'>
                  <img src={loginHand} alt="hand" />
                  <Typography className="fontBold font36 colorBlue">
                  Let's get started as
                  </Typography>
                  <Typography className="colorYellow font36 fontBold">
                  Sub-Vendor
                  </Typography>
                </Grid>
                <Grid item sm={7}>
                  <CommonForm
                    formData={loginFormSubVendor}
                    button={'Login'}
                    onSubmittBtn={onLogin}
                    loading={isLoader}
                  />
                </Grid>
              </Grid>
            <Typography className="colorGrey font18 fontNormal marginTop">Don't have an account ?<span className="colorBlue cursor" onClick={handleredirect}> Signup now</span></Typography>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' }}} className="bgImage">
            <div className="loginBgImg"></div>
          </Grid>
        </Grid>}
      </Box>}
      {onOtp&&<Otp onOtpPage={onOtpPage}/>}
      <TenantPicker
        open={tenantChoices.length > 0}
        tenants={tenantChoices}
        onSelect={onTenantSelect}
        onCancel={onTenantCancel}
      />
    </div>
  );
}
